/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Typography2 } from '@coursera/cds-core';

import TogglableContent from 'bundles/page/components/TogglableContent';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/video-logged-out-page';

const styles = {
  renderToggleButton: css`
    color: #0056d2;
    margin-right: 4px;
  `,
  toggleButtonContainer: css`
    align-items: center;
    display: flex;

    @media (max-width: 767px) {
      margin-top: 19px;
      justify-content: center;
    }
  `,
  courseDescriptionContainer: css`
    max-width: 786px;
  `,
  vlpContainerSection: css`
    margin-bottom: 2.5rem;
  `,
  aboutSection: css`
    margin-top: 12px;

    @media (max-width: 991px) {
      margin-top: 10px;
    }
  `,

  syllabusButton: css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 19px;
    height: 48px;
    min-width: 140px;
    max-width: 140px;
    padding: 0;
    border-radius: 2px;

    @media (max-width: 767px) {
      min-width: 100%;
      max-width: 100%;
      justify-content: center;
    }
  `,
};

type Props = {
  courseSlug: string;
  courseDescription: string;
};

const renderToggleButtonContent = ({ collapsed }: $TSFixMe) => (
  <div css={styles.toggleButtonContainer}>
    <Typography2
      component="h3"
      variant="subtitleMedium"
      data-e2e="course-description-toggle"
      css={styles.renderToggleButton}
    >
      {collapsed ? _t('SEE MORE') : _t('SEE LESS')}
    </Typography2>
    <i className={`${collapsed ? 'cif-chevron-down' : 'cif-chevron-up'}`} />
  </div>
);

const CourseDescription: React.FC<Props> = ({ courseSlug, courseDescription }) => {
  return (
    <div css={[styles.courseDescriptionContainer, styles.vlpContainerSection]}>
      {courseDescription && (
        <TogglableContent
          trackingName="description"
          css={styles.aboutSection}
          toggleButtonType="link"
          renderToggleButtonContentFunction={renderToggleButtonContent}
          disableCollapseScroll={true}
          collapsedHeight={84}
        >
          <Typography2 component="p" variant="bodyPrimary" data-e2e="course-description">
            {courseDescription}
          </Typography2>
        </TogglableContent>
      )}
      <Button
        href={`/learn/${courseSlug}#syllabus`}
        rel="noopener noreferrer"
        target="_blank"
        trackingName="vlp_view_syllabus_button"
        data-e2e="view-syllabus-button"
        component={TrackedLink2}
        variant="secondary"
        css={styles.syllabusButton}
      >
        {_t('View Syllabus')}
      </Button>
    </div>
  );
};

export default CourseDescription;
